import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import get from "lodash/get";
import Moment from "moment";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { instance } from "../../../../Actions/AxiosInstance";
import addressEmployee from "../../../../Assets/Images/education.svg";
import If from '../../../../Component/Common/If';
import createstore from "../../../../store";
import { getEJ2CalenderDateFormat, convertDateForBackend } from "../../../../Utils";
import './index.css';
import CreateComp from "../create";
import { NoRecordFound } from "../EmpMainProfile/NoRecordFound";
import { DatePickerComponent } from "../../../../Component/Custom";
import TextArea from "../../../../Component/Material-ui/TextArea";

const styles = (theme) => ({
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: "hidden",
        position: "relative",
        display: "flex",
    },
    // dense: {
    //     marginTop: 16,
    // },
    colorSwitchBase: {
        color: "#166ab3",
        "&$colorChecked": {
            color: "#166ab3",
            "& + $colorBar": {
                backgroundColor: "#666",
            },
        },
    },
    colorBar: {},
    colorChecked: {},
    iOSSwitchBase: {
        "&$iOSChecked": {
            color: "#166ab3",
            backgroundColor: "#166ab3",
            "& + $iOSBar": {
                backgroundColor: "#666",
            },
        },
        transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shortest,
            easing: theme.transitions.easing.sharp,
        }),
    },
    iOSChecked: {
        transform: "translateX(15px)",
        "& + $iOSBar": {
            opacity: 1,
            border: "none",
        },
    },
    iOSBar: {
        borderRadius: 13,
        width: 42,
        height: 26,
        marginTop: -13,
        marginLeft: -21,
        border: "solid 1px",
        // borderColor: theme.palette.grey[400],
        // backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(["background-color", "border"]),
    },
    iOSIcon: {
        width: 24,
        height: 24,
    },
    iOSIconChecked: {
        boxShadow: theme.shadows[1],
    },
    expand: {
        transform: "rotate(0deg)",
        transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: "rotate(45deg)",
    },

    educationGrades: [],
    allEducationalDetails: [],
});

class Doctorate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            employeeeducationid: null,
            educationgradeid: 5,
            datareceived: false,
            showform: false,
            isShuffle: false,
            allEducationalDetails: [],
            institutename: "",
            universityname: "",
            fromdate: "",
            todate: "",
            errorfromdate: false,
            errortodate: false,
            errorinstitutename: false,
            erroruniversityname: false,
            errorstudylevel: false,
            errorstudyfield: false,
            studylevel: null,
            studyfield: null,
            activities: null,
            hideButton: false,
            isbuttonDisabled: false,
            flag: 1,
            showBtn: false,
        };

        this.SetFlag = this.SetFlag.bind(this);
        this.EditEdu = this.EditEdu.bind(this);
        this.createNew = this.createNew.bind(this);
        this.Deleteconfirmation = this.Deleteconfirmation.bind(this);
        this.DeleteEdu = this.DeleteEdu.bind(this);
        this.getEditComponent = this.getEditComponent.bind(this);
        this.getViewComponent = this.getViewComponent.bind(this);
        this.getIntroComponent = this.getIntroComponent.bind(this);
    }

    componentDidMount() {
        // this.GetEducationGrade();
        const { SubscriptionInfo } = createstore.getState();
        const { accountid } = SubscriptionInfo.SubscriptionData;
        const { subscriptionid } = SubscriptionInfo.SubscriptionData;
        const { countrytimezoneid } = SubscriptionInfo.SubscriptionData;
        // let employeeid = SubscriptionInfo.SubscriptionData.employeeid;
        const DateFormat = get(SubscriptionInfo, "SubscriptionData.dateformatname", "");
        let ShortDateFormat = typeof DateFormat === "string" ? DateFormat.split(" ") : [""];
        ShortDateFormat = ShortDateFormat[0];
        let employeeid;
        employeeid = SubscriptionInfo.SubscriptionData.employeeid;

        const { AuthenticationAction } = createstore.getState();
        if (AuthenticationAction.IsFulfilled) {
            employeeid = AuthenticationAction.login.employeeid;
        }
        const { colleagueid } = this.props.match.params;

        const masterprofileid = get(AuthenticationAction, "login.masterprofileid", 9);
        const { permissions } = this.props;
        let hideButton;
        permissions.editable
            ? colleagueid && colleagueid != employeeid
                ? masterprofileid != 9
                    ? (hideButton = true)
                    : (hideButton = false)
                : (hideButton = false)
            : masterprofileid != 9 ? (hideButton = true) : (hideButton = false);
        this.setState(
            {
                accountid,
                subscriptionid,
                countrytimezoneid,
                employeeid,
                ShortDateFormat,
                colleagueid,
                hideButton,
                masterprofileid
            },
            () => {
                this.GetEducationalDetails();
            },
        );
    }

    // GetEducationGrade() {
    //     instance
    //         .get("superuser/getmastercode/EducationGrade")
    //         .then(result => {
    //             let educationGrades = [];
    //             educationGrades.push(
    //                 { displayname: "Select Education Grade", displayvalue: "" },
    //                 ...result.data.result
    //             );
    //             this.setState({ educationGrades });
    //         })
    //         .catch(error => {
    //             let CommonError = error.response ? error.response.data.error.message : error.message;
    //             this.props.enqueueSnackbar(CommonError, { variant: "error" });
    //         });
    // }


    AddEducationalDetails() {
        this.setState({ isbuttonDisabled: true });
        const data = {
            employeeeducationid: this.state.employeeeducationid,
            educationgradeid: this.state.educationgradeid,
            institutename: this.state.institutename,
            universityname: this.state.universityname,
            fromdate: convertDateForBackend(this.state.fromdate),
            todate: convertDateForBackend(this.state.todate),
            studylevel: this.state.studylevel,
            studyfield: this.state.studyfield,
            activities: this.state.activities,
            employeeid: this.props.colleagueid || this.state.employeeid,
        };
        if (!createstore.getState().AuthenticationAction.IsFulfilled) {
            Object.assign(data, {
                accountid: this.state.accountid,
                subscriptionid: this.state.subscriptionid,
                timezoneid: this.state.countrytimezoneid,
                employeeid: this.props.colleagueid || this.state.employeeid,
            });
        }
        const URL = "employee/insertupdateempeducation";
        instance
            .post(URL, data)
            .then((result) => {
                if (result && result.data.result[0] && result.data.result[0].isexecuted) {
                    this.props.enqueueSnackbar("saved successfully", { variant: "success" });
                }
                this.setState(
                    {
                        isEdit: false,
                        EditPerticularEdu: false,
                        employeeeducationid: null,
                        defaultEduMsg: false,
                        educationgradeid: 5,
                        institutename: "",
                        universityname: "",
                        fromdate: "",
                        todate: "",
                        flag: 1,
                        studyfield: "",
                        studylevel: "",
                        activities: '',
                    },
                    () => {
                        this.GetEducationalDetails();
                        this.props.UpdateStrength(true);
                        this.setState({ isbuttonDisabled: false, flag: 1, hideButton: false });
                    },
                );
            })
            .catch((error) => {
                this.setState({ isbuttonDisabled: false, flag: 2 });
                const CommonError = error.response ? error.response.data.error.message : error.message;
                this.props.enqueueSnackbar(CommonError, { variant: "error" });
            });
    }

    GetEducationalDetails() {
        const URL = "employee/getempalleducation";
        let data;
        if (createstore.getState().AuthenticationAction.IsFulfilled) {
            if (this.state.colleagueid) {
                data = {
                    employeeid: this.state.colleagueid,
                    accountid: this.state.accountid,
                    subscriptionid: this.state.subscriptionid,
                    timezoneid: this.state.countrytimezoneid,
                };
            } else {
                data = {};
            }
        } else {
            data = {
                accountid: this.state.accountid,
                subscriptionid: this.state.subscriptionid,
                timezoneid: this.state.countrytimezoneid,
                employeeid: this.state.employeeid,
            };
        }
        instance
            .post(URL, data)
            .then((result) => {
                let allEducationalDetails = [];
                result.data.result.length != 0
                    ? (allEducationalDetails = result.data.result)
                    : (allEducationalDetails = []);
                let defaultEduMsg;
                let flag;
                result.data.result.length <= 0 ? (defaultEduMsg = true) : (defaultEduMsg = false);

                const finalschooldetails = allEducationalDetails && allEducationalDetails.filter((education) => education.educationgradeid == 5);
                finalschooldetails && finalschooldetails <= 0 ? (flag = 0) : (flag = 1);
                this.setState({
                    allEducationalDetails: finalschooldetails, defaultEduMsg, datareceived: true, flag,
                });
            })
            .catch((error) => {
                const CommonError = error.response ? error.response.data.error.message : error.message;
                this.props.enqueueSnackbar(CommonError, { variant: "error" });
            });
    }

    EditEdu(item) {
        this.setState({
            employeeeducationid: item.employeeeducationid,
            educationgradeid: item.educationgradeid,
            institutename: item.institutename,
            universityname: item.universityname,
            fromdate: item.fromdate,
            todate: item.todate,
            flag: 2,
            studyfield: item.studyfield,
            studylevel: item.studylevel,
            activities: item.activities,
        });
    }

    createNew() {
        this.setState({
            employeeeducationid: null,
            fromdate: null,
            todate: null,
            studylevel: '',
            studyfield: '',
            universityname: '',
            institutename: '',
            activities: '',
            flag: 2,
        });
    }

    DeleteEdu(item) {
        let data;
        if (createstore.getState().AuthenticationAction.IsFulfilled) {
            if(this.state.masterprofileid && this.state.masterprofileid == 9){
            data = {employeeid: this.props.colleagueid || this.state.employeeid};
        }
        } else {
            data = {
                accountid: this.state.accountid,
                subscriptionid: this.state.subscriptionid,
                timezoneid: this.state.countrytimezoneid,
                employeeid: this.props.colleagueid || this.state.employeeid,
            };
        }
        
        const URL = `/employee/deleteempeducation/${item.employeeeducationid}`;
        instance
            .delete(URL, {data})
            .then(() => {
                this.setState(
                    {
                        educationgradeid: 5,
                        institutename: "",
                        universityname: "",
                        fromdate: null,
                        todate: null,
                        studyfield: "",
                        flag: 1,
                        studylevel: '',
                        activities: '',
                        employeeeducationid: null,
                    },
                    () => {
                        this.props.enqueueSnackbar("deleted successfully", { variant: "success" });
                        this.GetEducationalDetails();
                        this.props.UpdateStrength(true);
                    },
                );
            })
            .catch((error) => {
                this.setState({
                    flag: 1,
                });
                const CommonError = error.response ? error.response.data.error.message : error.message;
                this.props.enqueueSnackbar(CommonError, { variant: "error" });
            });
    }

    SetFlag(flag) {
        this.setState({
            flag,
        });
    }

    _onCreate = () => {
        // this.SetFlag(2);
        this.setState({ flag: 2, hideButton: true });
    }

    UpdateData(name, e) {
        if (name == 'institutename' && e.target.value == '') {
            this.setState({ [name]: e.target.value, errorinstitutename: true });
        } else if (name == 'universityname' && e.target.value == '') {
            this.setState({ [name]: e.target.value, erroruniversityname: true });
        } else if (name == 'studyfield' && e.target.value == '') {
            this.setState({ [name]: e.target.value, errorstudyfield: true });
        } else if (name == 'studylevel' && e.target.value == '') {
            this.setState({ [name]: e.target.value, errorstudylevel: true });
        } else if (name == 'institutename' && e.target.value != '') {
            this.setState({ [name]: e.target.value, errorinstitutename: false });
        } else if (name == 'universityname' && e.target.value != '') {
            this.setState({ [name]: e.target.value, erroruniversityname: false });
        } else if (name == 'studyfield' && e.target.value != '') {
            this.setState({ [name]: e.target.value, errorstudyfield: false });
        } else if (name == 'studylevel' && e.target.value != '') {
            this.setState({ [name]: e.target.value, errorstudylevel: false });
        } else if (name == 'activities') {
            this.setState({ [name]: e.target.value });
        }
    }

    UpdateDate(name, e) {
        if (name == 'fromdate' && !e.value) {
            this.setState({ [name]: e.value, errorfromdate: true });
        } else if (name == 'todate' && !e.value) {
            this.setState({ [name]: e.value, errortodate: true });
        } else if (name == 'fromdate' && e.value) {
            this.setState({ [name]: e.value, errorfromdate: false });
        } else if (name == 'todate' && e.value) {
            this.setState({ [name]: e.value, errortodate: false });
        }
    }

    Deleteconfirmation(item) {
        this.setState({ isEdit: false });
        this.props.enqueueSnackbar("Are you sure you want to delete?", {
            variant: "warning",
            action: [
                <Button
                    color="inherit"
                    size="small"
                    onClick={() => {this.DeleteEdu(item); this.props.closeSnackbar();}}
                >
                    Delete
                </Button>,
                <Button color="inherit" size="small" onClick={() => { this.setState({ isEdit: false }); this.props.closeSnackbar(); }}>
                    Dismiss
                </Button>,
            ],
        });
    }

    getIntroComponent() {
        const { hideButton } = this.state;
        return (
            <div>
                <Grid container>
                    <Grid item xs={12} md={12} sm={12}>
                        {!hideButton
                            ? <CreateComp
                                text="How much you've studied doesn't matter as much as how much you've learned. Nonetheless, tell how much you've studied."
                                heading="Doctorate details"
                                onCreate={this._onCreate}
                                imageSrc={addressEmployee}
                            />
                            : <NoRecordFound />
                        }
                    </Grid>
                </Grid>
            </div>
        );
    }

    getEditComponent() {
        return (
            <div className="emp-from-wrapper work-experience">
                <div className="form-height">
                    <div id="div">
                        <div className="custom-form-box profile-work-exp">
                            <div className="inner-wrapper">
                                <div className="form-group">
                                    <p className="input-form-label"><FormattedMessage id="LbInstituteName" defaultMessage="Institute name" /></p>
                                    <TextField
                                        className="Name"
                                        id="aaa"
                                        // label={<FormattedMessage id="LbInstituteName" defaultMessage="Institute name" />}
                                        defaultValue="Institute Name"
                                        margin="dense"
                                        variant="outlined"
                                        onChange={this.UpdateData.bind(this, "institutename")}
                                        value={this.state.institutename}
                                        inputProps={{ maxLength: 90 }}
                                        tabIndex="2"
                                        autoFocus
                                    />
                                    {this.state.errorinstitutename
                                        && <span className="caption-error margin-top-4 display-block">
                                            <FormattedMessage
                                                id="Erinstitutename"
                                                defaultMessage="please add institute name"
                                            />
                                        </span>}
                                </div>
                            </div>
                            <div className="inner-wrapper">
                                <div className="margin-bottom-20 ">
                                    <p className="input-form-label"><FormattedMessage id="LbEducationStartDate" defaultMessage="Start Date" /></p>
                                    <DatePickerComponent
                                        className="date"
                                        // onClick={() => this.dateObj1.show()}
                                        // ref={(date)) => this.dateObj1 = date}
                                        allowEdit={false}
                                        start="Decade"
                                        max={new Date()}
                                        depth="Year"
                                        format={getEJ2CalenderDateFormat("mmm,YYYY")}
                                        value={this.state.fromdate}
                                        change={(e) => this.UpdateDate("fromdate", e)}
                                        placeholder="From"
                                        width={"430px"}
                                    />
                                    {this.state.errorfromdate
                                        && <span className="caption-error">
                                            <FormattedMessage
                                                id="Erfromdate"
                                                defaultMessage="please add from date"
                                            />
                                        </span>}
                                </div>
                            </div>
                            <div className="inner-wrapper">
                                <div className="margin-bottom-20 ">
                                    <p className="input-form-label"><FormattedMessage id="LbEducationEndDate" defaultMessage="End Date" /></p>
                                    <DatePickerComponent
                                        className="end-date"
                                        start="Decade"
                                        depth="Year"
                                        min={this.state.fromdate}
                                        allowEdit={false}
                                        format={getEJ2CalenderDateFormat("mmm,YYYY")}
                                        value={this.state.todate}
                                        // onClick={() => this.dateObj2.show()}
                                        // ref={(date)) => this.dateObj2 = date}
                                        change={(e) => this.UpdateDate("todate", e)}
                                        placeholder="To"
                                        width={"430px"}
                                    />
                                    {this.state.errortodate
                                        && <span className="caption-error">
                                            <FormattedMessage
                                                id="Ertodate"
                                                defaultMessage="please add to date"
                                            />
                                        </span>}
                                </div>
                            </div>
                            <div className="inner-wrapper">
                                <div className="form-group">
                                    <p className="input-form-label"><FormattedMessage id="LbUniversityName" defaultMessage="University name" /></p>
                                    <TextField
                                        className="bbb"
                                        id="bbb"
                                        // label={
                                        //     <FormattedMessage id="LbUniversityName" defaultMessage="University name" />
                                        // }
                                        defaultValue="University name"
                                        margin="dense"
                                        variant="outlined"
                                        onChange={this.UpdateData.bind(this, "universityname")}
                                        value={this.state.universityname}
                                        inputProps={{ maxLength: 90 }}
                                        tabIndex="3"
                                    />
                                    {this.state.erroruniversityname
                                        && <span className="caption-error margin-top-4 display-block">
                                            <FormattedMessage
                                                id="Eruniversityname"
                                                defaultMessage="please add university name"
                                            />
                                        </span>}
                                </div>
                            </div>
                            <div className="inner-wrapper">
                                <div className="form-group">
                                    {/* <p className="input-form-label"><FormattedMessage id="Lbcoursename" defaultMessage="Course Name" /></p> */}
                                    <p className="input-form-label"><FormattedMessage id="Lblevelofstudy" defaultMessage="Level of study" /></p>
                                    <TextField
                                        id="bbb"
                                        className="study-level"
                                        // label={
                                        //     <FormattedMessage id="Lbcoursename" defaultMessage="Course Name" />
                                        // }
                                        margin="dense"
                                        variant="outlined"
                                        onChange={this.UpdateData.bind(this, "studylevel")}
                                        value={this.state.studylevel}
                                        inputProps={{ maxLength: 90 }}
                                        tabIndex="3"
                                    />
                                    {this.state.errorstudylevel
                                        && <span className="caption-error margin-top-4 display-block">
                                            <FormattedMessage
                                                id="Erstudylevel"
                                                defaultMessage="please add course name"
                                            />
                                        </span>}
                                </div>
                            </div>
                            <div className="inner-wrapper">
                                <div className="form-group">
                                    <p className="input-form-label"><FormattedMessage id="Lbcoursetype" defaultMessage="Field of study / major (optional)" /></p>
                                    <TextField
                                        id="bbb"
                                        className="studyfield"
                                        // label={
                                        //     <FormattedMessage id="Lbcoursetype" defaultMessage="Course Type" />
                                        // }

                                        margin="dense"
                                        variant="outlined"
                                        onChange={this.UpdateData.bind(this, "studyfield")}
                                        value={this.state.studyfield}
                                        inputProps={{ maxLength: 90 }}
                                        tabIndex="3"
                                    />
                                </div>
                            </div>
                            <div className="inner-wrapper">
                                <div style={{ width: 430 }}>
                                    <p className="input-form-label"><FormattedMessage id="LbactivitesOptional" defaultMessage="Activities (optional)" /></p>

                                    <TextArea
                                        className="width100 activity"
                                        onChange={this.UpdateData.bind(this, "activities")}
                                        value={this.state.activities}
                                        maxLength="255"
                                        tabIndex="3"
                                        variant="outlined"
                                        multiline
                                    />
                                </div>
                            </div>
                            <div className="margin-top-15">
                                <span
                                    className={this.state.isbuttonDisabled ? "hide-event" : ""}
                                    onClick={this.AddEducationalDetails.bind(this)}
                                    tabIndex="5"
                                >
                                    <Button
                                        variant="contained"
                                        size="large"
                                        color="primary"
                                        className="lifeevent-btn save"
                                    >
                                        <span>
                                            <FormattedMessage id="BtSave" defaultMessage="SAVE" />
                                        </span>
                                    </Button>
                                </span>
                                <span tabIndex="6" className="margin-left-5" onClick={() => this.SetFlag(this.state.allEducationalDetails.length < 1 ? 0 : 1)}>
                                    <Button size="large" className="lifeevent-btn cancel">
                                        <span>
                                            <FormattedMessage id="BtCancel" defaultMessage="Cancel" />
                                        </span>
                                    </Button>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }

    getViewComponent() {
        const { hideButton } = this.state;
        return (
            <div>
                {this.state.allEducationalDetails.map((item) => (
                    <div className="profile-view-block" key="key">
                        <If condition={!hideButton}>
                            <div className="position-rel">
                                <svg
                                    className={
                                        this.state.hideButton ? "hide-button" : "address-edit cursour-pointer"
                                    }
                                    onClick={() => this.EditEdu(item)}
                                    width="24"
                                    style={{ marginRight: 40 }}
                                    height="24"
                                    viewBox="0 0 24 24"
                                >
                                    <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z" />
                                </svg>


                                <svg className={
                                    this.state.hideButton ? "hide-button" : "address-edit cursour-pointer"
                                }
                                    onClick={() => this.Deleteconfirmation(item)}
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z" />
                                    <path fill="none" d="M0 0h24v24H0V0z" />
                                </svg>
                            </div>
                        </If>
                        <div className="width90">


                            <div className="position-rel">
                                <div className="address-data">
                                    {item.educationgradename !== "" ? item.educationgradename : ""}
                                </div>
                            </div>
                            <div className="position-rel">
                                <div className="address-data">
                                    {item.institutename !== "" ? item.institutename : ""}
                                </div>
                            </div>
                            <div className="position-rel">
                                <div className="address-data">
                                    {Moment(item.fromdate).format("YYYY")} to{" "}
                                    {Moment(item.todate).format("YYYY")}
                                </div>
                            </div>
                            <div className="position-rel">
                                <div className="address-data">
                                    {item.universityname !== "" ? item.universityname : ""}
                                </div>
                            </div>
                            <div className="position-rel">
                                <div className="address-data">
                                    {item.studyfield !== "" ? item.studyfield : ""}
                                </div>
                            </div>
                            <div className="position-rel">
                                <div className="address-data">
                                    {item.studylevel !== "" ? item.studylevel : ""}
                                </div>
                            </div>
                            <div className="position-rel">
                                <div className="address-data">
                                    {item.activities !== "" ? item.activities : ""}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
                {!hideButton && <div tabIndex="6" onClick={this.createNew}>
                    <Button size="large" style={{ background: '#166ab3', color: 'white' }} className="ADD-more" >
                        <span>
                            <FormattedMessage id="LbAddmore" defaultMessage="ADD MORE" />
                        </span>
                    </Button>
                </div>}
            </div>
        );
    }

    render() {
        const { datareceived, flag } = this.state;
        return (
            <div>
                <If condition={datareceived}>
                    <If condition={flag == 0}>{this.getIntroComponent()}</If>
                    <If condition={flag == 1}>{this.getViewComponent()}</If>
                    <If condition={flag == 2}>{this.getEditComponent()}</If>
                </If>
            </div>
        );
    }
}

Doctorate.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(withSnackbar(Doctorate));
